import React from 'react';

const renderTextWithLineBreaks = text => {
    return text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));
};

export { renderTextWithLineBreaks };
